import { sum as p } from "@project-rouge/rg-core";
function b(l, n, c, a = 0.1) {
  const t = c.clone().sub(n), e = l.clone().sub(n);
  let o = t.clone().multiply(e).toArray().reduce(p) / t.lengthSq();
  o = Math.min(1, Math.max(0, o));
  const s = t.clone().multiplyScalar(o).add(n);
  return l.clone().sub(s).lengthSq() < a * a;
}
export {
  b as isOnLine
};
//# sourceMappingURL=index19.js.map
